<script lang="ts" setup>

  // Props
  const props = defineProps({
    titulo: String,
    subtitulo: String
  })

  // Scroll Store
  const scroll = useScrollStore()
  const { isScrolledInput } = storeToRefs(scroll)

  const parallaxText = ref<HTMLElement | null>(null)

  const handleScroll = () => {
    const scrollPosition = window.scrollY
    if (parallaxText.value && window.innerWidth >= 768) {
      parallaxText.value.style.transform = `translateY(${scrollPosition * 0.3}px)`
    }
  }

  onMounted(() => {
    window.addEventListener('scroll', handleScroll)
  })

  onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll)
  })

  const [tituloPart1, tituloPart2] = props?.titulo?.split(' ') ?? []

</script>

<template>

  <div class="flex flex-col w-full justify-center max-w-5xl mx-auto gap-4 z-10">
    
    <!-- Fondo para mobile -->
    <div class="relative w-full bg-[#b9b19f]/75 md:bg-transparent">
      <div class="absolute h-full md:hidden w-full">
        <div class="absolute top-3 right-3 z-20">
          <NuxtImg quality="100" src="/img/leaf.webp" preload format="webp" class="h-11 w-11 object-contain rotate-y-180" />
        </div>
        <!-- <NuxtImg
          src="/home/background.webp"
          provider="s3Provider"
          preload
          width="400"
          height="500"
          format="webp"
          alt="Fondo cama hotel"
          class="w-full h-full object-cover"
        /> -->

        <NuxtImg
          src="/img/fondo_navidad.webp"
          preload
          width="400"
          height="500"
          format="webp"
          alt="Fondo cama hotel"
          class="w-full h-full object-cover"
        />

      </div>

      <div class="flex flex-col relative m-5 shadow sm:shadow-none border sm:border-0 border-neutral-100/30 pt-2 rounded-3xl backdrop-blur-sm md:backdrop-blur-none">

        <!-- Overlay con degradado -->
        <div class="md:hidden absolute inset-0 bg-linear-to-b from-black/15 to-white/25 rounded-3xl"></div>

        <div ref="parallaxText" class="text-center p-4 md:pt-4 md:mb-4">
          <h1 class="text-7xl text-white md:text-black drop-shadow md:drop-shadow-none sm:text-9xl lg:text-[10rem] pb-2 text-wrap">
            <span class="block md:inline md:mr-8">{{ tituloPart1 }}</span>
            <span class="block md:inline">{{ tituloPart2 }}</span>
          </h1>
          <p class="text-md md:text-xl md:pb-1 text-white drop-shadow md:drop-shadow-none md:text-neutral-500">{{ subtitulo }}</p>
        </div>

        <div class="hidden md:block relative w-full max-w-5xl mx-auto">
          <div class="absolute -top-4 -right-3 z-20">
            <NuxtImg quality="100" src="/img/leaf.webp" preload format="webp" class="h-16 w-16 object-contain rotate-y-190" />
          </div>

          <div class="backdrop-blur rounded-3xl overflow-hidden h-[35vh] bg-gray-50">
            <!-- <NuxtImg
              src="/home/background.webp"
              provider="s3Provider"
              preload
              width="1000"
              height="350"
              format="webp"
              alt="Fondo cama hotel"
              class="w-full h-full object-cover opacity-75"
            /> -->
  
            <NuxtImg
              src="/img/fondo_navidad.webp"
              preload
              format="webp"
              alt="Fondo cama hotel"
              class="w-full h-full object-cover opacity-75"
            />
          </div>
        </div>

        <div v-show="!isScrolledInput" class="md:mx-auto p-3 md:-mt-10">
          <SearchInput/>
        </div>
        <div v-if="isScrolledInput" class="h-40 md:h-6">
        </div>

      </div>

    </div>

  </div>
</template>